{
    "SymbolLabel": "Símbolo:",
    "SymbolNote": "(Aplica automaticamente as alterações aos campos abaixo)",
    "PatternLabel": "Padrão:",
    "GroupingseparatorLabel": "Separador de Agrupamento:",
    "GroupingseparatorOptionCommaDesc": "(Vírgula)",
    "GroupingseparatorOptionSpaceDesc": "(Espaço)",
    "GroupingseparatorOptionFullstopDesc": "(Ponto final)",
    "DecimalseparatorLabel": "Separador decimal:",
    "DecimalseparatorOptionFullstopDesc": "(Ponto final)",
    "DecimalseparatorOptionColonDesc": "(Cólon)",
    "DecimalseparatorOptionCommaDesc": "(Vírgula)",
    "PreviewLabel": "Pré-visualizar",
    "CurrencyDisplayFormat_SectionHeader": "Formato de apresentação de moeda",
    "NAME": "CurrencyDisplayFormat"
}